import { useMemo } from "react";
import { useAnalyticsContext } from "../BricksProvider.mjs";
const useObservabilitySafe = () => {
  const {
      useObservability
    } = useAnalyticsContext(),
    {
      trackJourneyEvent
    } = useObservability();
  return useMemo(() => ({
    trackJourneyEvent: (...args) => {
      try {
        trackJourneyEvent(...args);
      } catch {}
    }
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
};
export { useObservabilitySafe };